
<template>
    <li class="notice-item">
        <a href="javascript:void(0)"
           @click.stop.prevent="$emit('itemClicked')">{{name}}
            <span v-if="isNew"
                  class="notice-new">
                <img src="//awp-assets.meituan.net/hfe/fep/8998afcc22bad060d889bc2aee1766d5/newnotice.svg" />
            </span>
        </a>
        <span>{{date}}</span>
    </li>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            date: {
                type: String,
                required: true
            },
            isNew: {
                type: Boolean,
                default: false
            }
        }
    };
</script>
<style lang="postcss">
    .notice-item {
      display: flex;
      height: 50px;
      line-height: 50px;
      box-shadow: inset 0 -0.5px 0 0 #dce3ea;
      &:nth-child(4) {
        box-shadow: none;
      }
      a {
        flex: 1 0 20px;
        color: #333d48;
        line-height: 50px;
        &:hover,
        &:focus {
          color: #37a6fc;
          text-decoration: none;
        }
        & .notice-new {
          display: inline-block;
          height: 14px;
          width: 31px;
          padding-left: 4px;
        }
      }
      span {
        flex: 0 0 6em;
        align-self: flex-end;
        font-size: 12px;
        color: #93999f;
        font-weight: 300;
        text-align: right;
      }
    }
</style>



// WEBPACK FOOTER //
// noticeItem.vue?f60c5f04